import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import '../layout/style.css';

const Home = () => (
  <Paper align="center">
    <Typography variant="display2" gutterBottom>
      Welcome to Video Services
    </Typography>
  </Paper>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/Home.js